import ActionList from './ActionList.vue'
import {setActionList} from './ActionListMenu.vue'

setActionList(ActionList)

export {
  ActionList
}
